import { ICON_SPRITE, type IconName } from '@/assets/icons/sprite.generated';
import { cn } from '@/lib/cn';

export type { IconName };

interface IconProps {
  name: IconName;
  size?: number | undefined;
  className?: string | undefined;
  label?: string | undefined;
}

export function Icon({ name, size = 24, className, label }: IconProps): React.JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={cn('shrink-0', className)}
      style={{ color: 'currentColor' }}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      focusable="false"
    >
      <use href={`#mv-${name}`} />
    </svg>
  );
}

export function IconSprite(): React.JSX.Element {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}
      dangerouslySetInnerHTML={{ __html: ICON_SPRITE }}
    />
  );
}
